import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs';

/**
 * 並び替え機能制御
 */
export default class extends Controller<HTMLElement> {
  static override values = { targetTagName: String };
  static override targets = ['row', 'input'];

  declare sortable: Sortable | undefined;

  // HTMLの方にdata-sortable-target-tag-name-value="..."を指定することで取得できる
  declare targetTagNameValue?: string;

  declare rowTargets: HTMLElement[];
  declare inputTarget: HTMLInputElement;

  override connect(): void {
    this.initializeSortable();
  }

  override disconnect(): void {
    if (this.sortable) {
      this.sortable.destroy();
      this.sortable = undefined;
    }
  }

  /**
   * Sortable初期化
   */
  private initializeSortable() {
    const tagName = this.targetTagNameValue ?? 'tbody'; // デフォルトでtbodyを指定
    const element = this.element as HTMLElement;

    // sortableを適用する要素をタグ名から取得
    const targetElement = element.querySelector(tagName) as HTMLElement | null;

    // 対象の要素が存在しない場合は何もしない
    if (!targetElement) {
      return;
    }

    this.sortable = Sortable.create(targetElement, {
      handle: '[data-sort-handle]', // 掴む要素の指定
      animation: 150,
      onEnd: () => {
        this.updateOrders();
      },
    });

    // 初期状態のorder値を設定
    this.updateOrders();
  }

  /**
   * 並び順IDを設定する
   */
  private updateOrders(): void {
    // すべての行のidを取得（上から順番に取得）
    const ids = this.rowTargets
      .map(row => row.dataset.id)
      .filter((id): id is string => Boolean(id));

    // 並び替え後のidをhidden inputに設定
    const input = this.inputTarget;
    if (input) input.value = ids.join(',');
  }
}
